import moment from "moment";
import { useState } from "react";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import EndPoints from "src/Constants/EndPoints";
import useLoading from "src/Hooks/Custom/useLoading";
import useApiMutation from "src/Hooks/Shared/useApiMutation";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import ConfirmModal from "../ConfirmModal/ConfirmModal";
import ReportModal from "../ReportModal/ReportModal";
import Rating from 'react-rating';
import { useTranslation } from "react-i18next";
import useApiFetch from "src/Hooks/Shared/useApiFetch";
import SnackbarHandler from "src/Utils/SnackbarHandler";

function BusinessPostlDetail({
  postData,
  setPostData,
  setDetailView,
  setModalVisibility,
}: any) {
  const { user } = AppStateHandler.getState();
  const { t, i18n } = useTranslation();
  const [commentText, setCommentText] = useState("");
  const [rating, setRating] = useState(0);

  const [confirmModal, setConfirmModal] = useState<boolean>(false);
  const {
    id,
    title,
    message,
    images,
    location,
    email,
    phone_number,
    likes,
    total_comments,
    timestamp,
    subId
  } = postData;

  //ratings
  const getCommentsUrl =
    EndPoints.businessPostComments +
    "?postId=" +
    id +
    "&subId=" +
    user?.username;
  const { data: commentsResponse, refetch } = useApiFetch([getCommentsUrl], {});
  const { Items: comments = [] } = commentsResponse?.data ?? {};




  const [reportData, setReportData] = useState<any>();
  const [showReportModal, setShowReportModal] = useState<boolean>(false)

  const detailViewHandler = (e: any) => {
    e.preventDefault();
    setPostData([]);
    setDetailView(false);
  };
  const editPostHandler = (e: any) => {
    e.preventDefault();
    setModalVisibility(true);
  };

  // review
  const [commentPost, { status: commentStatus }] = useApiMutation({
    onSuccess: () => {
      setCommentText("");
      refetch();
    }
  });
  const handleReportComment = (id: number) => {
    const report = {
      data: { commentId: id },
      endPoint: EndPoints.reportComment,
    };
    setReportData(report);
    setShowReportModal(true);
  };

  const commentHandler = async (e: any) => {
    e.preventDefault();
    if (commentStatus === "loading") {
      return;
    }
    if (commentText.trim() === '') {
      SnackbarHandler.emptyCommentWarningToast(t("Please add a review"));
      return;
    }
    try {
      await commentPost({
        url: EndPoints.commentOnBusinessPost,
        data: {
          postId: id,
          subId: user?.username,
          comment: commentText,
          likes: rating,
        },
      });
      setRating(0);
    } catch (error) {
      console.log(error);
    }
  };
  // review
  const ratingChanged = (rating: number) => {
    setRating(rating)
  }
  const [deletePost, { status: deleteStatus }] = useApiMutation({
    onSettled: () => {
      setDetailView(false);
      setConfirmModal(false);
    }
  });
  useLoading(deleteStatus);

  const deleteFn = (e: any) => {
    e && e.preventDefault();
    if (deleteStatus === "loading") {
      return;
    }
    deletePost({
      url: EndPoints.deleteBusinessPost,
      method: 'DELETE',
      data: {
        subId: user?.username,
        postId: id,
      },
    });
  };
  return (
    <>
      <div className="d-flex justify-content-between px-3">
        <a
          className="d-flex mb-4 align-items-center"
          onClick={detailViewHandler}
          href="/"
        >
          <i className={`${i18n.dir() === 'rtl' ? 'fa fa-angle-right fz24' : 'fa fa-angle-left fz24'}`} aria-hidden="true"></i>
          <h3 className={`fz16 mb-0 ${i18n.dir() === 'rtl' ? 'mr-3 Almaraibold' : 'ml-3'}`}>{t("Detail")}</h3>
        </a>
        <div className="slider_down_arrow position-relative">
          <i className="fa fa-angle-down fz26" aria-hidden="true"></i>
          <div className={`user_actions ${i18n.dir()==='rtl'?'user_actions_posRTL':'user_actions_posLTR'}`}> 
            <ul className={`list-unstyled  ${i18n.dir()==='rtl'?'text-right Almaraibold':'text-left poppinsbold'} mb-0 `}>
              <VisibilityToggle visible={user.username === subId}>
                <li>
                  <a className="py-4" href="/" onClick={editPostHandler}>
                    {t('Edit')}
                  </a>
                </li>
              </VisibilityToggle>
              <VisibilityToggle visible={user.username === subId}>
                <li>
                  <a className="py-4" href="/" onClick={(e) => {
                    e.preventDefault();
                    setConfirmModal(true)
                  }}>
                    {t('Delete')}
                  </a>
                </li>
              </VisibilityToggle>
              <VisibilityToggle visible={user.username !== subId}>
                <li>
                  <a className="py-4" href="/" onClick={(e) => {
                    e.preventDefault();
                    setReportData({ postId: id });
                    setShowReportModal(true)
                  }}>
                    {t('Report')}
                  </a>
                </li>
              </VisibilityToggle>
            </ul>
          </div>
        </div>
      </div>
      <div className="px-3">
        <div className="row">
          <div className="col-md-5">
            <div className="col_selector mb-5 mb-md-0">
              <img
                src={images[0].url}
                className="img-fluid w-100 rounded"
                alt=""
              />
            </div>
          </div>
          <div className="col-md-7">
            <div className="col_selector">
              <div>
                <div className="mb-3 d-flex flex-column align-self-center">
                  <h3 className={`fz16 poppinssemibold mb-0  ${i18n.dir() === 'rtl' ? 'text-right ' : ''}`}>
                    {title}
                  </h3>
                  <span>
                    <p className={`fz12 mb-0 pt-2 pb-3  ${i18n.dir() === 'rtl' ? 'text-right Almarairegular' : 'poppinsregular'}`}>
                      <Rating className="text-warning"
                        emptySymbol="fa fa-star-o "
                        fullSymbol="fa fa-star"
                        fractions={2}
                        initialRating={likes}
                        readonly
                        direction={i18n.dir()}
                      />
                      <span className={`fz12  px-2  ${i18n.dir() === 'rtl' ? 'Almarairegular' : 'poppinsregular'}`}>{total_comments + " " + t('Reviews')}</span>
                    </p>
                  </span>
                </div>
                <p className={`fz12 poppinsregular  ${i18n.dir() === 'rtl' ? 'pr-0 text-right ' : 'pl-0 '}`}>{message}</p>
                <hr />
                <p className="pl-0">
                  <a className="fz10 poppinsregular base_color" href={'mailto:' + email}>{email}</a>
                </p>
                <p className={`fz11 pl-0 poppinsregular base_color ${i18n.dir()==='rtl'?'text-right ':''}`}>
                  {phone_number}
                </p>
                <p className={`fz11 poppinsregular  ${i18n.dir() === 'rtl' ? 'text-right' : ''}`}>
                  <i className={`fa fa-map-marker fz16  ${i18n.dir() === 'rtl' ? 'icon-spacing-RTL' : 'icon-spacing-LTR'}`} aria-hidden="true"> </i>{location}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="py-5 px-3">
          <div className="mb-4">
            <h3 className={`fz16 mb-0 ${i18n.dir() === 'rtl' ? 'text-right' : ''}`}>{t("Reviews")}</h3>
          </div>
          {comments.map((comment: any, i: number) => {
            return (
              <div key={i} className="d-flex">
                <div className={`${i18n.dir() === 'rtl' ? 'ml-3' : 'mr-3'}`}>
                  <img
                    src={
                      comment.picture !== ""
                        ? comment.picture
                        : "/assets/images/profile-camera.png"
                    }
                    className="rounded-circle object_fit"
                    width="40"
                    height="40"
                    alt=""
                  />
                </div>
                <div className="w-100">
                  <div className={`d-flex align-items-center justify-content ${i18n.dir() === 'rtl' ? 'text-right' : ''}`}>
                    <h4 className="fz16 mb-1 mb-4 poppinssemibold">
                      {comment.name} <br />
                      <span className="fz11 poppinsregular">
                      <Rating className="text-warning"
                        emptySymbol="fa fa-star-o "
                        fullSymbol="fa fa-star"
                        fractions={2}
                        initialRating={comment.likes}
                        readonly
                        direction = {i18n.dir()}
                      /></span>
                      <i className={`fz10  text-secondary  ${i18n.dir()==='rtl'?'mr-2 Almaraisemibold':'ml-2 poppinsregular'}`}>
                        {comment.timestamp
                          ? moment(new Date(comment.timestamp)).fromNow()
                          : ""}
                      </i>
                    </h4>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                    <p className="fz14 poppinsregular text-secondary pl-0 mb-0">
                      {comment.comment}
                    </p>
                    <span className="text-secondary fz12 cursor-pointer">
                      <span
                        className="ml-2 exclamation"
                        onClick={() => handleReportComment(comment.id)}
                      >
                        <i
                          className={`fa fa-exclamation base_color`}
                          aria-hidden="true"
                        ></i>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
          <div className="d-flex">
            <div className="mr-3"></div>
            <div className="w-100 position-relative mt-4">
              <div className={`d-flex flex-column justify-content-between ${i18n.dir() === 'rtl' ? 'text-right Almaraibold' : ''}`}>
                <span>{t("Add Review")}</span>
                <span>
                  <span className={`fz13 mb-0  pt-2 pb-3 text-secondary ${i18n.dir() === 'rtl' ? 'Almarairegular' : 'poppinsregular'}`}>
                    {t("Rating")}
                  </span>
                  <Rating className="text-warning fz14 mb-0 poppinsregular pt-2 pb-3 mx-2"
                    emptySymbol="fa fa-star-o "
                    fullSymbol="fa fa-star"
                    fractions={2}
                    initialRating={rating}
                    onChange={ratingChanged}
                    direction={i18n.dir()}
                  />
                </span>

              </div>

              <div className="position-relative">
                <textarea
                  maxLength={150}
                  name="review"
                  value={commentText}
                  className={`form-control fz14 p-2 ${i18n.dir() === 'rtl' ? 'pl-5 Almarairegular' : 'pr-5 poppinsregular'}`}
                  style={{ backgroundColor: "rgb(245, 245, 245)" }}
                  placeholder={t("Share your experience at this place")}
                  onChange={(e: any) => setCommentText(e.target.value)}
                />
                <VisibilityToggle visible={commentStatus === "loading"}>
                  <span
                    className="spinner-border spinner-border-sm position-absolute"
                    style={{ right: "40px", top: "10px" }}
                  ></span>
                  &nbsp; &nbsp;
                </VisibilityToggle>
                <i
                  className={`fa fa-paper-plane position-absolute base_color cursor-pointer ${i18n.dir() === 'rtl' && "fa-flip-horizontal"}`}
                  style={{ right: `${i18n.dir()==='rtl'?'':'18px'}`, top: "10px", left: `${i18n.dir()==='rtl'?'18px':''}`}}
                  aria-hidden="true"
                  onClick={commentHandler}
                ></i>
              </div>

            </div>
          </div>

        </div>

        {confirmModal ? (
          <ConfirmModal
            showModal={confirmModal}
            setModalVisibility={setConfirmModal}
            confirmAction={deleteFn}
            ConfirmationText={"Are you sure?"}
            CancelBtnText={"Cancel"}
            ConfirmBtnText={"Yes"}
            status={deleteStatus}
          />
        ) : (
          <></>
        )}
        {showReportModal ? (
          <ReportModal
            data={reportData.data}
            setData={setReportData}
            type={"business"}
            showModal={showReportModal}
            setModalVisibility={setShowReportModal}
            endPoint={reportData.endPoint}
          />
        ) : (
          <></>
        )}
      </div>

    </>
  );
}

export default BusinessPostlDetail;
